import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['button'];

	connect() {
		this.onFavoritesChanged = this.onFavoritesChanged.bind(this);
		this.onClick = this.onClick.bind(this);

		document.addEventListener('study:favorites-changed', this.onFavoritesChanged);
		this.element.addEventListener('click', this.onClick);

		this.refreshState();
	}

	disconnect() {
		document.removeEventListener('study:favorites-changed', this.onFavoritesChanged);
		this.element.removeEventListener('click', this.onClick);
	}

	onFavoritesChanged() {
		this.refreshState();
	}

	onClick(event) {
		const button = event.target instanceof Element
			? event.target.closest('[data-compare-action-state-target="button"]')
			: null;

		if (!button || button.getAttribute('aria-disabled') !== 'true') {
			return;
		}

		event.preventDefault();
		event.stopPropagation();
	}

	refreshState() {
		const hasComparedItems = this.element.querySelector('[data-compare-action-state-item][aria-pressed="true"]') !== null;
		this.buttonTargets.forEach((button) => this.setButtonState(button, hasComparedItems));
	}

	setButtonState(button, enabled) {
		const isDisabled = !enabled;

		button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
		button.classList.toggle('pointer-events-none', isDisabled);
		button.classList.toggle('opacity-70', isDisabled);
		button.classList.toggle('cursor-not-allowed', isDisabled);
		button.tabIndex = isDisabled ? -1 : 0;
	}
}
